import * as React from 'react';

function useLatest<T>(value: T): React.MutableRefObject<T> {
    const ref = React.useRef<T>(value); // initialized → non-nullable
    ref.current = value;                // keep in sync every render
    return ref;
}

export default useLatest;
